import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const ODOO_URL = process.env.REACT_APP_ODOO_URL || 'http://localhost:8069';
const ODOO_CONFIGURATOR_URL = `${ODOO_URL}/website/configurator`;

/**
 * OdooConfigurator — redirects the user directly to the Odoo website configurator.
 * The Snagcart header bar is injected into Odoo itself via the snagcart_branding addon,
 * so the user sees a consistent Snagcart UI without any iframe cross-origin issues.
 */
const OdooConfigurator = () => {
  useEffect(() => {
    // Redirect to Odoo configurator in the same tab
    window.location.href = ODOO_CONFIGURATOR_URL;
  }, []);

  return (
    <div className="min-h-screen bg-[#080808] flex flex-col items-center justify-center gap-4">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center"
        style={{ background: 'linear-gradient(135deg, #f97316 0%, #f59e0b 100%)' }}
      >
        <svg width="22" height="22" viewBox="0 0 14 14" fill="none">
          <path d="M2 3.5h10M2 7h6.5M2 10.5h5" stroke="white" strokeWidth="1.4" strokeLinecap="round"/>
          <circle cx="11" cy="9.5" r="2.5" fill="white" fillOpacity="0.9"/>
          <path d="M10 9.5l.8.8L12.5 8.5" stroke="#f97316" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="flex items-center gap-2 text-zinc-400 text-sm">
        <Loader2 className="w-4 h-4 animate-spin text-violet-400" />
        Opening Snagcart Website Configurator…
      </div>
      <p className="text-zinc-600 text-xs">
        If you are not redirected automatically,{' '}
        <a
          href={ODOO_CONFIGURATOR_URL}
          className="text-violet-400 hover:text-violet-300 underline"
        >
          click here
        </a>
      </p>
    </div>
  );
};

export default OdooConfigurator;
